import type { BasePageOrSubPage } from '../../services/models/pagelist-models'

export abstract class WorkflowState<PagesE extends BasePageOrSubPage> {
    public currentPage: keyof PagesE
}
